import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import _Input from "../../../generic/_Input";
import Template from "../../Template";
import ShortUrls from "../ShortUrls";
import { useFormikContext } from "formik";

import _Button from "../../../generic/_Button";
import _ModalPreview from "./_ModalPreview";
import { useReplaceMessage } from "../../../../hooks/useReplaceMessage";
import _EmailControl from "./_EmailControl";
import { useStripHtml } from '../../hooks/useStripHtml';
const EmailForm = ({ step }) => {
  const { values, setFieldValue, handleChange, handleBlur, errors } =
    useFormikContext();

  const replaceMessage = useReplaceMessage(values.fieldsInfo);
  const stripHtml = useStripHtml();
  const strip = stripHtml(values.email_message);

  const [preview, setPreview] = useState({
    data: {
      subject: null,
      message: null,
    },
    visible: false,
  });


  useEffect(() => {
    const templateMessage = replaceMessage(values.email_message);

    setFieldValue("email_template", templateMessage);
  }, [values.email_message]);

  return (
    <div className="bg-white px-4 py-2 rounded-lg">
      <div className="px-4">
        <div className="flex items-end gap-2 my-2">
          <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
            <span className="font-bold">{step}</span>
          </div>
          <div className="text-xl font-bold text-gray-600">Mensaje Email</div>
        </div>
      </div>

      <_Input
        title="Asunto"
        name="email_subject"
        id="email_subject"
        value={values.email_subject}
        onChange={handleChange}
        handleBlur={handleBlur}
        errors={errors && errors.email_subject}
        isError={errors && errors.email_subject ? true : false}
        required
      />

      <_EmailControl
        name={"email_message"}
        value={values.email_message}
        onChange={(e) => setFieldValue("email_message", e.target.value)}
        errors={errors}
        title="Mensaje Email"
        required
      />

      <div className="flex justify-end my-1">
        <_Button
          style={`${strip ? "primary" : "none"}`}
          title="Previsualizar"
          disabled={!strip}
          icon={strip ? "visibility" : "visibility_off"}
          onClick={() =>
            setPreview({
              data: {
                subject: values.email_subject,
                message: values.email_template,
              },
              visible: true,
            })
          }
        />
      </div>

      <div className="grid grid-cols-2 gap-4 border rounded-lg px-2 py-1">
        <Template
          onChange={(e) => setFieldValue("email_message", e)}
          value={values.email_message}
        />
        <ShortUrls
          onChange={(e) => setFieldValue("email_message", e)}
          value={values.email_message}
        />
      </div>
      <_ModalPreview
        onClose={() =>
          setPreview({
            data: {
              subject: null,
              message: null,
            },
            visible: false,
          })
        }
        data={preview.data}
        visible={preview.visible}
        title="Vista previa del email"
      />
    </div>
  );
};

EmailForm.propTypes = {
  step: PropTypes.number,
};

export default EmailForm;
